// extracted by mini-css-extract-plugin
module.exports = {"viewElement":"SimpleFooter_viewElement__Wzpj3"};